import React, {useCallback, useMemo} from 'react';

import {RadioButton, RadioButtons} from '@pb/kit-component-radio-button';

import {PERMISSION_LEVELS} from './constants';
import {getLevel, getSelectedCodes, getTreeCodes, hasLevelPermission} from './utils';

import type {PermissionLevels, PermissionTreeItem} from './typedef';

type Props = {
    moduleName: string,
    disabled?: boolean,
    codes: string[],
    tree: PermissionTreeItem,
    onTreeChange?: (permissions: string[]) => void,
};

export const PermissionTree = ({moduleName, codes, tree, onTreeChange, disabled}: Props) => {

    const onChange = useCallback((selectedLevel: PermissionLevels) => {
        const treeCodes = getTreeCodes(tree);
        const selectedCodes = getSelectedCodes(selectedLevel, tree);

        if (onTreeChange) {
            onTreeChange([...codes.filter(code => !treeCodes.includes(code)), ...selectedCodes]);
        }
    }, [tree, codes, onTreeChange]);

    const levels = useMemo(() => (
        [...PERMISSION_LEVELS as PermissionLevels[]]
            .filter((level: PermissionLevels) => hasLevelPermission(tree, level))
    ), [tree]);

    return (
        <RadioButtons
            disabled={disabled}
            name={moduleName}
            onChange={onChange}
            value={getLevel(codes, tree)}
            grouping={{
                direction: 'h',
                style: {'--gr__j': 'space-around'},
            }}>
            {[...PERMISSION_LEVELS as PermissionLevels[]].map(level => (levels.includes(level)
                ? <RadioButton key={level} showLabel={false} value={level}/>
                : <div key={level} style={{width: 21}}/>
            ))}
        </RadioButtons>
    );
};
